__turbopack_context__.v({
  "dot": "AudiencePill-module__-7UsJa__dot",
  "dotActive": "AudiencePill-module__-7UsJa__dotActive",
  "link": "AudiencePill-module__-7UsJa__link",
  "linkActive": "AudiencePill-module__-7UsJa__linkActive",
  "pill": "AudiencePill-module__-7UsJa__pill",
});
